"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DATEDIF = void 0;
const tab_1 = require("../../../tab");
exports.DATEDIF = {
    description: 'difference between two dates in days month and year',
    arg_names: ['date', 'dateToCompare', 'format'],
    args_def: [
        {
            types: ['date'],
            required: true,
        },
        {
            types: ['date'],
            required: true,
        },
        {
            types: ['enum(DAY | MONTH | YEAR | HOUR | MINUTE | SECOND)'],
            required: true,
        },
    ],
    args_description: [
        'date to be compare',
        'date to be compare',
        'format that the date should be converted to',
    ],
    return_type: tab_1.ColumnType.INTEGER,
};
